import classNames from 'classnames'
import { Tooltip } from './Tooltip'

export function Stats({
  title,
  count,
  breakdown,
  unitType = `unitless`,
  wrapperClassName,
  children,
  disableStyling,
}: {
  title: string
  count: number
  breakdown: { colorHex?: string; name: string; count: number }[]
  unitType?: `unitless` | `percentage` | `dollars`
  wrapperClassName?: string
  children: React.ReactNode
  disableStyling?: boolean
}) {
  return (
    <Tooltip
      placement="bottom-start"
      message={
        <div className="flex max-w-sm flex-col gap-y-4 p-2">
          <div className="flex flex-col gap-1">
            <p className="text-body-sm inverse-text-strong">{title}</p>
            <p className="text-ui-lg inverse-text-strong">
              {unitType === `dollars` && `$`}
              {Math.floor(count).toLocaleString(`en-US`)}
              {unitType === `percentage` && `%`}
            </p>
          </div>
          <div className="flex flex-col gap-y-3">
            {breakdown?.map((item, index) => (
              <div key={index} className="flex items-center justify-between gap-x-4">
                <div className="flex items-center">
                  {!!item.colorHex && (
                    <div className="mr-2 h-2 w-2 rounded-full" style={{ backgroundColor: item.colorHex }}></div>
                  )}
                  <p className="text-body-xs text-minimal">{item.name}</p>
                </div>
                <p className="text-ui-xs inverse-text-strong">
                  {unitType === `dollars` && `$`}
                  {Math.floor(item.count).toLocaleString(`en-US`)}
                  {unitType === `percentage` && `%`}
                </p>
              </div>
            ))}
          </div>
        </div>
      }
    >
      <div className={disableStyling ? `` : `flex h-full w-full items-center justify-start px-2 text-body-xs`}>
        <div className={classNames(`group-hover/cell:stats-hover`, wrapperClassName)}>{children}</div>
      </div>
    </Tooltip>
  )
}
